import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { useTranslation } from "next-i18next";

import { EL_ID_TOP_PANEL } from "@/components/TopPanel/TopPanel.constants";
import { selectorSystemIsTopPanelVisible } from "@/shared/store/system/selectors";
import Typography from "@/shared/components/Typography/Typography";

import styles from "./top-panel.module.scss";

const TopPanelLoader = () => {
  const { t } = useTranslation();
  const isTopPanelVisible = useSelector(selectorSystemIsTopPanelVisible);

  return (
    <div
      id={EL_ID_TOP_PANEL}
      className={classNames(styles["top-panel"], {
        [styles["hidden"]]: !isTopPanelVisible,
      })}>
      <Typography variant="h2" className={styles["title-wrap"]}>
        <Typography className={styles["title"]} threeDots fontFamily={Typography.fontFamily.bebas}>
          {t("loading")}…
        </Typography>
      </Typography>
    </div>
  );
};

export default TopPanelLoader;
